export const comCopy = {
  com_layout_title: "Bagaimana cara mempersiapkan TypeScript",
  com_layout_description:
    "Terhubung dengan pengguna TypeScript secara daring dan luring.",
  com_headline: "Terhubung dengan kami",
  com_connect_online: "Daring",
  com_connect_online_description:
    " Beri tahu kami apa yang bekerja dengan baik, apa yang ingin Anda tambahkan atau tingkatkan, dan cari tahu mengenai pembaruan terbaru.",
  com_online_stack_overflow_desc:
    "Ajak teman Anda dan ajukan pertanyaan mengenai TypeScript menggunakan tanda pagar 'typescript'",
  com_online_stack_overflow_tag: "",
  com_online_discord_header: "Obrolan",
  com_online_discord_desc:
    "Mengobrol dengan pengguna TypeScript lainnya pada Obrolan Komunitas TypeScript.",
  com_online_github_desc:
    "Menemukan bug atau ingin memberikan umpan balik yang membangun?",
  com_online_github_href: "Beritahu kami di GitHub",
  com_online_twitter_desc: "Tetap terkini. Ikuti kami di Twitter",
  com_online_blog_desc:
    "Pelajari mengenai perkembangan TypeScript terbaru melalui",
  com_online_typed_desc: "Berkas definisi TypeScript",
  com_online_typed_href: "Cari ribuan",
  com_online_typed_available_for:
    "tersedia untuk perpustakaan dan kerangka kerja umum.",
  com_person: "Terhubung secara langsung",
  com_conferences: "Konferensi",
  com_conferences_alt_img: "logo dari ",
}
